import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSun = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.92688 18.0727L7.61133 22.5948L12 20.5883L16.3887 22.5948L18.0732 18.0727L22.5953 16.3882L20.5887 11.9995L22.5953 7.61084L18.0732 5.92639L16.3887 1.4043L12 3.41081L7.61133 1.4043L5.92688 5.92639L1.40479 7.61084L3.4113 11.9995L1.40479 16.3882L5.92688 18.0727ZM15.265 19.8819L12 18.3891L8.73504 19.8819L7.48189 16.5177L4.11767 15.2645L5.61042 11.9995L4.11767 8.73456L7.48189 7.4814L8.73504 4.11718L12 5.60993L15.265 4.11718L16.5182 7.4814L19.8824 8.73456L18.3896 11.9995L19.8824 15.2645L16.5182 16.5177L15.265 19.8819ZM12 16.9995C9.2386 16.9995 7.00002 14.761 7.00002 11.9995C7.00002 9.23811 9.2386 6.99953 12 6.99953C14.7614 6.99953 17 9.23811 17 11.9995C17 14.761 14.7614 16.9995 12 16.9995ZM15 11.9995C15 13.6564 13.6569 14.9995 12 14.9995C10.3432 14.9995 9.00002 13.6564 9.00002 11.9995C9.00002 10.3427 10.3432 8.99953 12 8.99953C13.6569 8.99953 15 10.3427 15 11.9995Z",
		fill: "#256F94"
	})
});
export default SvgSun;
